export const ALL_STORIES_CATEGORY_ID = undefined;

export const ALL_STORIES_CATEGORY = {
    id: ALL_STORIES_CATEGORY_ID,
    title: 'All',
    path: '/resources',
};
